import React from "react";
import styled from "styled-components";
import { useLocation } from "react-router";

const BookItemStyled = styled.div`
    text-align: center;
    margin-top: 20px;
    width: 246px;
    border: 1px solid #dfdfdf;
    border-radius: 10px;
    font-weight: 400;
    font-family: 'Ploni ML v2 AAA', sans-serif;

    user-select: none;

    @media (max-width: 1000px) {
        width: 100%;
    }
`;

const ImageStyled = styled.div`
    border-radius: 10px;

    &:active {
        cursor: grab;
    }

    img {
        width: 100%;
        height: 215px;
        border-radius: 10px;
        object-fit: cover;
        user-select: none;
        pointer-events: none;

        @media (max-width: 600px) {
            height: 127px;
        }
    }
`;


const CtaStyled = styled.div`
    margin-top: 17px;
    margin-bottom: 17px;

    a {
        display: inline-block;
        padding: 10px 20px;
        background-color: #FFA726;
        color: #000;
        text-decoration: none;
        border-radius: 8px;
        font-family: Arial, sans-serif;
        font-size: 16px;
        font-weight: bold;
        text-align: center;

        &:hover {
            background-color: #ff9700;
        }

    }
`;

const CtaWrapperStyled = styled.div`
    padding: 0 3px 20px 3px;

    h3 {
        font-size: 19px;
        margin: 8px 0 0 0;
        padding: 0;
        font-weight: 400;
        height: 22px;

        @media (max-width: 600px) {
            font-size: 14px;
        }
    }
`;

const BookItem = ({ item, langData, lang, config }) => {
    const location = useLocation();
    const queryParameters = new URLSearchParams(location.search);
    const clientId = queryParameters.get("clientId") || "64d491633684ef0d32edb473";


    const titleFontSize = item.title.length > 21 ? "14px" : "19px";
    let frameUrl = "https://app.mebook.ai";
    if (config?.domain) {
        frameUrl = `https://app.${ config.domain }`;
    }
    let link = `${ frameUrl }?clientId=${ clientId }&language=${ lang }&templateId=${ item._id }`;

    if (config.editorUrlTemplate && config.appBaseUrl) {
        const baseEditorUrl = config.editorUrlTemplate
            .replaceAll("{{appBaseUrl}}", config.appBaseUrl)
            .replaceAll("editor/preview", "")
            .replaceAll("{{language}}", lang);

        const params = `templateId=${ item._id }&clientId=${ clientId }&language=${ lang }`;
        link = `${ baseEditorUrl }?${ params }`;
    }

    return (
        <BookItemStyled>
            <ImageStyled>
                <img src={ item.imageUrl } alt="" />
            </ImageStyled>
            <CtaWrapperStyled>
                <h3 style={ { fontSize: titleFontSize } }>{ item.title }</h3>
                <CtaStyled>
                    <a href={ link } target="_blank" rel="noreferrer">
                        { langData.shop_now }
                    </a>
                </CtaStyled>
            </CtaWrapperStyled>
        </BookItemStyled>
    );
};

export default BookItem;
